import type { PaginationProps } from 'antd';
import { Pagination } from 'antd';
import React from 'react';

const AppPagination: React.FC<PaginationProps> = ({ className, ...props }) => {
  return (
    <div className={['w-full flex justify-center', className].filter(Boolean).join(' ')}>
      <Pagination showSizeChanger={false} hideOnSinglePage {...props} />
    </div>
  );
};

AppPagination.displayName = 'AppPagination';

export default AppPagination;
